export default __webpack_public_path__ + "static/gatlinburg-5a18d0f3480a4cb959edb21026a43a59.png";